// @ts-nocheck
import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope, faEdit } from "@fortawesome/free-regular-svg-icons";
import UserImage from "components/User/Image/UserImage";
import "./UserPreviewDrawer.css";
import { t } from "i18next";
import { QueryTagsList } from "components/Tags/TagsList/TagsList";
import genRequest from "includes/request";
import InfosFetcher from "components/InfosFetcher/InfosFetcher";
import SaveUserBtn from "components/User/SaveUserBtn/SaveUserBtn";
import Button from "components/Button/Button";
import { OnlineStatus } from "components/User/Card/UserCard";
import { DatePreview } from "components/User/AuthorPreview/AuthorPreview";
import PasswordReset from "./PasswordReset";

export default function UserPreviewDrawer(props) {

	let user = props.user;

	const handleModify = () => {
		if (props.handleModify)
			props.handleModify(user);
	};

	useEffect(() => {
		document.body.classList.add("hiding-mobileMenu");
		return () => {
			document.body.classList.remove("hiding-mobileMenu");
		};
	}, []);

	return (
		<div className="UserPreviewDrawer">
			<div className="user-preview d-flex mb-2">
				<div className="user-image-cont d-flex flex-column align-items-center">
					<UserImage
						className="me-2"
						companyId={user.companyId}
						employeeId={user.employeeId}
						title={user.firstName + " " + user.lastName}
					/>
					<div className="d-flex flex-column gap-2 mb-2">
						<SaveUserBtn className={"radius-5"} text={t("Commons.FAVORITE")} userId={user.employeeId} />
						{
							props.handleModify &&
							<Button className="radius-5 w-auto btn-primary" onClick={handleModify}>
								<div className="d-flex align-items-center">
									{t("Commons.MODIFY")}
									<FontAwesomeIcon className="ms-2" icon={faEdit} />
								</div>
							</Button>
						}
					</div>
				</div>
				<div className="user-infos">
					<div>
						<div className="d-flex align-items-center gap-2">
							<OnlineStatus lastConnexion={user?.lastConnexion} employeeId={user.employeeId} />
							<div className="d-flex flex-wrap user-fullname font-bold">
								<div>{user.firstName}&nbsp;</div>
								<div>{user.lastName.toUpperCase()}</div>
							</div>
						</div>
						<QueryTagsList
							className="mt-1"
							queryKey={["Groups", "GroupsOfEmploye", user.employeeId]}
							queryFn={() => genRequest("groups/employee/" + user.employeeId)}
							enabled={(user && user.employeeId) ? true : false}
						/>
						<InfosFetcher
							queryFn={() => genRequest("sites/" + user.siteId)}
							queryKey={["Sites", user.siteId]}
							treat={(infos) => {
								return infos.siteName + (infos.town ? " - " + infos.town : "");
							}}
						/>
						<InfosFetcher
							queryFn={() => genRequest("employees/" + user.employeeId + "/complete")}
							queryKey={["Employes", "Complete", user.employeeId]}
							treat={(infos) => {
								return (
									<>
										<div className="user-work-function">{infos?.wfu?.name}</div>
										<div className="user-work-family">{infos?.wfy?.name}</div>
									</>
								);
							}}
						/>
					</div>
					<div className="user-contacts">
						{
							user.displayMail && user.mail &&
							<div className="user-contact user-mail">
								<a href={"mailto:" + user.mail}><FontAwesomeIcon className="user-contact-icon" icon={faEnvelope} />{user.mail}</a>
							</div>
						}
						{
							user.displayPhone && user.phone &&
							<div className="">
								<div className="user-contact user-whatsapp">
									<a href={"whatsapp:" + user.phone}><FontAwesomeIcon className="user-contact-icon" icon={faWhatsapp} />Whatsapp</a>
								</div>
								<div className="user-contact user-phone">
									<a href={"tel:" + user.phone}><FontAwesomeIcon className="user-contact-icon" icon={faPhoneAlt} />{user.phone}</a>
								</div>
							</div>
						}
						{
							!user.displayMail && !user.displayPhone &&
							<div className="no-contact-info-msg">{t("Contacts.HIDDEN_INFOS")}</div>
						}
					</div>
					<div className="d-flex gap-1 user-work-family mt-2">
						{t("User.LAST_CONN")}
						:
						{
							user.lastConnexion ?
								<DatePreview
									date={user.lastConnexion}
									max={1}
								/>
								:
								" " + t("User.NO_CONN")
						}
					</div>
				</div>
			</div>
			<PasswordReset user={user} className="mt-3" />
		</div>
	);
}
